export const CONTACT_DATA = {
  email: "ost.tomasz@gmail.com",
  phone: "+48 513 738 524",
  phoneRaw: "+48513738524",
  address: "59-300 Lubin, Poland",
  nip: "000-000-00-00",
} as const;

export const SOCIAL_DATA = [
  { id: "instagram", href: "https://instagram.com", label: "Instagram" },
  { id: "twitter", href: "https://twitter.com", label: "Twitter" },
  { id: "facebook", href: "https://facebook.com", label: "Facebook" },
  {
    id: "linkedin",
    href: "https://linkedin.com/in/tomasz-ostaszewski-7166071aa",
    label: "LinkedIn",
  },
] as const;

export const FEATURES = [
  {
    id: 1,
    icon: "antenna-1",
    title: "Global Reach",
    description:
      "Connecting your business to the world with advanced satellite technology.",
  },
  {
    id: 2,
    icon: "clock-1",
    title: "Swift Delivery",
    description:
      "Time is money. We ensure your projects are completed ahead of schedule.",
  },
  {
    id: 3,
    icon: "diagram-1",
    title: "Data Insights",
    description:
      "Smart analytics to help you visualize growth and optimize performance.",
  },
  {
    id: 4,
    icon: "astronaut-1",
    title: "Future Tech",
    description:
      "Bold solutions that push the boundaries of what's possible in IT.",
  },
] as const;

import trump1 from "../assets/images/trump1.jpg";
import trump1_2x from "../assets/images/trump1@2x.jpg";
import trump2 from "../assets/images/trump2.jpg";
import trump2_2x from "../assets/images/trump2@2x.jpg";
import trump3 from "../assets/images/trump3.jpg";
import trump3_2x from "../assets/images/trump3@2x.jpg";

export const SERVICES = [
  { id: 1, title: "Desktop Apps", img: trump1, img2x: trump1_2x },
  { id: 2, title: "Mobile Apps", img: trump2, img2x: trump2_2x },
  { id: 3, title: "Design Solutions", img: trump3, img2x: trump3_2x },
] as const;

import team1 from "../assets/images/team1.jpg";
import team1_2x from "../assets/images/team1@2x.jpg";
import team2 from "../assets/images/team2.jpg";
import team2_2x from "../assets/images/team2@2x.jpg";
import team3 from "../assets/images/team3.jpg";
import team3_2x from "../assets/images/team3@2x.jpg";
import team4 from "../assets/images/team4.jpg";
import team4_2x from "../assets/images/team4@2x.jpg";

export const TEAM_MEMBERS = [
  {
    id: 1,
    name: "Mark Guerrero",
    role: "Product Designer",
    img: team4,
    img2x: team4_2x,
  },
  {
    id: 2,
    name: "Tom Ford",
    role: "Frontend Developer",
    img: team3,
    img2x: team3_2x,
  },
  {
    id: 3,
    name: "Camila Garcia",
    role: "Marketing",
    img: team2,
    img2x: team2_2x,
  },
  {
    id: 4,
    name: "Daniel Wilson",
    role: "UI Designer",
    img: team1,
    img2x: team1_2x,
  },
] as const;

export const CLIENT_ICONS = [
  "client1",
  "client2",
  "client3",
  "client4",
  "client5",
  "client6",
] as const;

// Portfolio 1
import port1 from "../assets/images/portfolio1.jpg";
import port1_2x from "../assets/images/portfolio1@2x.jpg";
import port1_mid from "../assets/images/portfoliomid1.jpg";
import port1_mid2x from "../assets/images/portfoliomid1@2x.jpg";
import port1_max from "../assets/images/portfoliomax1.jpg";
import port1_max2x from "../assets/images/portfoliomax1@2x.jpg";

// Portfolio 2
import port2 from "../assets/images/portfolio2.jpg";
import port2_2x from "../assets/images/portfolio2@2x.jpg";
import port2_mid from "../assets/images/portfoliomid2.jpg";
import port2_mid2x from "../assets/images/portfoliomid2@2x.jpg";
import port2_max from "../assets/images/portfoliomax2.jpg";
import port2_max2x from "../assets/images/portfoliomax2@2x.jpg";

// Portfolio 3
import port3 from "../assets/images/portfolio3.jpg";
import port3_2x from "../assets/images/portfolio3@2x.jpg";
import port3_mid from "../assets/images/portfoliomid3.jpg";
import port3_mid2x from "../assets/images/portfoliomid3@2x.jpg";
import port3_max from "../assets/images/portfoliomax3.jpg";
import port3_max2x from "../assets/images/portfoliomax3@2x.jpg";

// Portfolio 4
import port4 from "../assets/images/portfolio4.jpg";
import port4_2x from "../assets/images/portfolio4@2x.jpg";
import port4_mid from "../assets/images/portfoliomid4.jpg";
import port4_mid2x from "../assets/images/portfoliomid4@2x.jpg";
import port4_max from "../assets/images/portfoliomax4.jpg";
import port4_max2x from "../assets/images/portfoliomax4@2x.jpg";

// Portfolio 5
import port5 from "../assets/images/portfolio5.jpg";
import port5_2x from "../assets/images/portfolio5@2x.jpg";
import port5_mid from "../assets/images/portfoliomid5.jpg";
import port5_mid2x from "../assets/images/portfoliomid5@2x.jpg";
import port5_max from "../assets/images/portfoliomax5.jpg";
import port5_max2x from "../assets/images/portfoliomax5@2x.jpg";

// Portfolio 6
import port6 from "../assets/images/portfolio6.jpg";
import port6_2x from "../assets/images/portfolio6@2x.jpg";
import port6_mid from "../assets/images/portfoliomid6.jpg";
import port6_mid2x from "../assets/images/portfoliomid6@2x.jpg";
import port6_max from "../assets/images/portfoliomax6.jpg";
import port6_max2x from "../assets/images/portfoliomax6@2x.jpg";

// Portfolio 7
import port7 from "../assets/images/portfolio7.jpg";
import port7_2x from "../assets/images/portfolio7@2x.jpg";
import port7_mid from "../assets/images/portfoliomid7.jpg";
import port7_mid2x from "../assets/images/portfoliomid7@2x.jpg";
import port7_max from "../assets/images/portfoliomax7.jpg";
import port7_max2x from "../assets/images/portfoliomax7@2x.jpg";

// Portfolio 8
import port8 from "../assets/images/portfolio8.jpg";
import port8_2x from "../assets/images/portfolio8@2x.jpg";
import port8_mid from "../assets/images/portfoliomid8.jpg";
import port8_mid2x from "../assets/images/portfoliomid8@2x.jpg";
import port8_max from "../assets/images/portfoliomax8.jpg";
import port8_max2x from "../assets/images/portfoliomax8@2x.jpg";

// Portfolio 9
import port9 from "../assets/images/portfolio9.jpg";
import port9_2x from "../assets/images/portfolio9@2x.jpg";
import port9_mid from "../assets/images/portfoliomid9.jpg";
import port9_mid2x from "../assets/images/portfoliomid9@2x.jpg";
import port9_max from "../assets/images/portfoliomax9.jpg";
import port9_max2x from "../assets/images/portfoliomax9@2x.jpg";

export const PORTFOLIO_PROJECTS = [
  {
    id: 1,
    title: "Technocrack",
    category: "Webpages",
    description:
      "Zaawansowany serwis internetowy dedykowany analizie trendów technologicznych, charakteryzujący się minimalistycznym designem i wysoką wydajnością.",
    img: port1,
    img2x: port1_2x,
    imgMid: port1_mid,
    imgMid2x: port1_mid2x,
    imgMax: port1_max,
    imgMax2x: port1_max2x,
  },
  {
    id: 2,
    title: "Grafika New Orlean vs Golden Star",
    category: "Design",
    description:
      "Dynamiczny projekt identyfikacji wizualnej dla wydarzenia sportowego, łączący nowoczesną typografię z ekspresyjną ilustracją.",
    img: port2,
    img2x: port2_2x,
    imgMid: port2_mid,
    imgMid2x: port2_mid2x,
    imgMax: port2_max,
    imgMax2x: port2_max2x,
  },
  {
    id: 3,
    title: "Restauracja Seafood",
    category: "Applications",
    description:
      "Intuicyjny system rezerwacji stolików i przeglądania menu online, stworzony z myślą o miłośnikach świeżych owoców morza.",
    img: port3,
    img2x: port3_2x,
    imgMid: port3_mid,
    imgMid2x: port3_mid2x,
    imgMax: port3_max,
    imgMax2x: port3_max2x,
  },
  {
    id: 4,
    title: "Projekt Prime",
    category: "Marketing",
    description:
      "Kompleksowa kampania promująca nową linię akcesoriów audio, skupiona na podkreśleniu głębi dźwięku i elegancji wykonania.",
    img: port4,
    img2x: port4_2x,
    imgMid: port4_mid,
    imgMid2x: port4_mid2x,
    imgMax: port4_max,
    imgMax2x: port4_max2x,
  },
  {
    id: 5,
    title: "Projekt Boxes",
    category: "Applications",
    description:
      "Innowacyjna aplikacja do zarządzania logistyką i magazynowaniem, optymalizująca proces pakowania i wysyłki towarów.",
    img: port5,
    img2x: port5_2x,
    imgMid: port5_mid,
    imgMid2x: port5_mid2x,
    imgMax: port5_max,
    imgMax2x: port5_max2x,
  },
  {
    id: 6,
    title: "Inspiration has no Borders",
    category: "Webpages",
    description:
      "Multimedialna platforma edukacyjna inspirująca twórców z całego świata do dzielenia się swoimi projektami bez ograniczeń geograficznych.",
    img: port6,
    img2x: port6_2x,
    imgMid: port6_mid,
    imgMid2x: port6_mid2x,
    imgMax: port6_max,
    imgMax2x: port6_max2x,
  },
  {
    id: 7,
    title: "Magazyn Limited Edition",
    category: "Design",
    description:
      "Projekt layoutu ekskluzywnego magazynu o modzie i sztuce, kładący nacisk na przejrzystość i wysokiej jakości fotografię.",
    img: port7,
    img2x: port7_2x,
    imgMid: port7_mid,
    imgMid2x: port7_mid2x,
    imgMax: port7_max,
    imgMax2x: port7_max2x,
  },
  {
    id: 8,
    title: "Projekt LAB",
    category: "Marketing",
    description:
      "Kreatywna strategia brandingowa dla nowoczesnego laboratorium, akcentująca profesjonalizm i dbałość o detale.",
    img: port8,
    img2x: port8_2x,
    imgMid: port8_mid,
    imgMid2x: port8_mid2x,
    imgMax: port8_max,
    imgMax2x: port8_max2x,
  },
  {
    id: 9,
    title: "Growing Business",
    category: "Applications",
    description:
      "Zintegrowane narzędzie CRM wspomagające rozwój małych i średnich przedsiębiorstw poprzez automatyzację sprzedaży.",
    img: port9,
    img2x: port9_2x,
    imgMid: port9_mid,
    imgMid2x: port9_mid2x,
    imgMax: port9_max,
    imgMax2x: port9_max2x,
  },
] as const;

export const PORTFOLIO_FILTERS = [
  "All",
  "Webpages",
  "Applications",
  "Design",
  "Marketing",
] as const;

export type PortfolioCategory = (typeof PORTFOLIO_FILTERS)[number];

export const CONTACT_DETAILS = [
  {
    icon: "phone",
    label: "Phone",
    value: CONTACT_DATA.phone,
    link: `tel:${CONTACT_DATA.phoneRaw}`,
  },
  {
    icon: "email",
    label: "Email",
    value: CONTACT_DATA.email,
    link: `mailto:${CONTACT_DATA.email}`,
  },
  {
    icon: "location",
    label: "Address",
    value: CONTACT_DATA.address,
    link: null,
  },
  { icon: "briefcase", label: "NIP", value: CONTACT_DATA.nip, link: null },
] as const;

export const SOCIAL_LINKS = [
  { name: "github", url: "https://github.com/OstTomasz" },
  {
    name: "linkedin",
    url: "https://www.linkedin.com/in/tomasz-ostaszewski-7166071aa/",
  },
  { name: "instagram", url: "https://instagram.com" },
] as const;
